"use client";

import { cn } from "@repo/shared/utils";
import type { ClassValue } from "clsx";
import { type VariantProps, cva } from "class-variance-authority";

const headingVariants = cva("", {
  variants: {
    size: {
      h1: "text-3xl",
      h2: "text-2xl",
      h3: "text-xl",
      h4: "text-lg",
    },
  },
  defaultVariants: {
    size: "h1",
  },
});

export interface HeadingProps extends VariantProps<typeof headingVariants> {
  title: string;
  className?: ClassValue;
}
export const Heading = ({ title, className, size }: HeadingProps) => {
  return <h1 className={cn(headingVariants({ size, className }))}>{title}</h1>;
};
